import { useEffect, useState } from "react";
import API_BASE from "../apiConfig";

export default function HealthChip() {
  const [ok, setOk] = useState(null); // null = loading

  useEffect(() => {
    let live = true;
    const ping = () =>
      fetch(`${API_BASE}/health`)
        .then(r => (r.ok ? r.json() : Promise.reject()))
        .then(() => live && setOk(true))
        .catch(() => live && setOk(false));

    ping();
    const id = setInterval(ping, 5000);
    return () => { live = false; clearInterval(id); };
  }, []);

  const label = ok === null ? "Kollar API…" : ok ? "API up" : "API down";
  const bg = ok === null ? "#9CA3AF" : ok ? "#16A34A" : "#DC2626";

  return (
    <span title={label} style={{
      display:"inline-flex", alignItems:"center", gap:8,
      padding:"6px 10px", borderRadius:9999, background:"#F3F4F6",
      border:"1px solid #E5E7EB", color:"#111827", fontSize:12
    }}>
      <span style={{ width:8, height:8, borderRadius:"50%", background:bg }} />
      {label}
    </span>
  );
}
